module.exports = __webpack_public_path__ + "static/media/wave.8a550a2a.png";